import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {ToastrModule} from 'ngx-toastr';
import {AppComponent} from './app.component';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from './app-routing.module';
import {ComponentsModule} from './components/components.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AuthModule, EventTypes, LogLevel, OidcConfigService, PublicEventsService} from 'angular-auth-oidc-client';
import {EditorModule} from '@progress/kendo-angular-editor';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {DemoMaterialModule} from "./shared/material-module";
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {DBConfig, NgxIndexedDBModule} from "ngx-indexed-db";
import {GregorianDate} from "./shared/pipe/gregorianDate";
import {DateJalali} from "./shared/pipe/dateJalali";
import {GregorianTime} from "./shared/pipe/gregorianTime";
import {TimeJalali} from "./shared/pipe/timeJalali";
import {ForbiddenComponent} from "./Forbidden/Forbidden.component";
import {APP_BASE_HREF} from "@angular/common";
import {filter} from "rxjs/operators";




export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');

}

export function configureAuth(oidcConfigService: OidcConfigService) {
  return () =>
    oidcConfigService.withConfig({
      clientId: '5052f0fd-0ff6-4f68-873d-c0fe246b9ff6',
      stsServer: 'https://mac.medis.land',
      responseType: 'code',
      redirectUrl: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      silentRenew: true,
      useRefreshToken: true,
      silentRenewUrl: `${window.location.origin}/silent-renew.html`,
      renewTimeBeforeTokenExpiresInSeconds: 10,
      // silentRenew: true,
      // useRefreshToken: true,
      // silentRenewUrl: `${window.location.origin}/silent-renew.html`,
      // renewTimeBeforeTokenExpiresInSeconds: 9,
      scope: 'openid profile apiService_1bc9b913-257e-4250-b6df-6002ad5c7faf offline_access',
      //logLevel: LogLevel.Debug,
    });
}



const dbConfig: DBConfig  = {
  name: 'Jobino',
  version: 3,
  objectStoresMeta: [{
    store: 'Images',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'MD5', keypath: 'MD5', options: { unique: false } },
      { name: 'icon', keypath: 'icon', options: { unique: false } },
    ]
  }]
};

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    DemoMaterialModule,
    FontAwesomeModule,
    AppRoutingModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    AuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot(),
    EditorModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production, scope: '/', registrationStrategy: 'registerImmediately' }),
  ],
  declarations: [AppComponent, AdminLayoutComponent,ForbiddenComponent

  ],
  providers: [
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService],
      multi: true,
    },{provide: APP_BASE_HREF, useValue: '/'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  // constructor(private readonly eventService: PublicEventsService) {
  //   this.eventService
  //     .registerForEvents()
  //     .pipe(filter((notification) => notification.type === EventTypes.ConfigLoaded))
  //     .subscribe((config) => {
  //       console.log('ConfigLoaded', config);
  //     });
  // }
}
